<script>
    import Card from '@smui/card';
</script>
<div class="container-fluid">
    <div class="row justify-content-center">
        <div class="col-12">
            <Card>
                <div class="cng-card__primary cng-card__header-with-buttons">
                    <div class="mdc-typography--headline5">
                        <slot/>
                    </div>
                </div>
                <div class="cng-card__divider"></div>
                <div class="cng-card__secondary">
                    Verbinding verbroken. Probeer de pagina te herladen.
                </div>
            </Card>
        </div>
    </div>
</div>